import angular from 'angular';

import { AlcSidenavController } from './sidenav/alc-sidenav.controller';
import { MetricCategoryHelperService } from './sidenav/metric-category-helper.service';

import { NavigationPublishController } from './subnav/publish.controller.js';
import { NavigationMetricsController } from './subnav/metrics.controller.js';
import { NavigationParametersController } from './subnav/navigation.parameters.controller.js';
import { NavigationPreferencesController } from './subnav/navigation.preferences.controller.js';

import { TopToolbarService } from './top-toolbar/top-toolbar.service';
import { topToolbar } from './top-toolbar/top-toolbar.directive';

import { SiteFilterHelperService } from './site-filter/site-filter-helper.service';
import { siteFilterMaterial } from './site-filter/site-filter.directive';

angular
  .module('core', [])

  .controller('AlcSidenavController', AlcSidenavController)
  .factory('MetricCategoryHelperFactory', MetricCategoryHelperService.MetricCategoryHelperFactory)

  .controller('NavigationPublishController', NavigationPublishController)
  .controller('NavigationPreferencesController', NavigationPreferencesController)
  .controller('NavigationParametersController', NavigationParametersController)
  .controller('NavigationMetricsController', NavigationMetricsController)

  .factory('TopToolbarFactory', TopToolbarService.TopToolbarFactory)
  .directive('topToolbar', topToolbar)

  .factory('SiteFilterHelperFactory', SiteFilterHelperService.SiteFilterHelperFactory)
  .directive('siteFilterMaterial', siteFilterMaterial)
  ;
